var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleCalendar = function SvgGoogleCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.173 512.001"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.086)",
    fill: "#a5b7d1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1151",
    d: "m511.379 459.1-29.542-142.014 29.542-142.013c2.432-11.608-.676-26.137-9.941-37.074a44.932 44.932 0 0 0-19.328-13.332V45.086a45.051 45.051 0 0 0-45-45h-361a45.051 45.051 0 0 0-45 45v79.239C8.956 131.573-3.441 154.633.84 175.074l29.542 142.013S.763 459.492.729 459.689a45 45 0 0 0 44.388 52.4H467.1a45 45 0 0 0 44.388-52.4c-.033-.2-.069-.394-.11-.59ZM76.109 30.086h361a15.017 15.017 0 0 1 15 15v77h-391v-77a15.017 15.017 0 0 1 15-15Zm402.438 446.7a14.774 14.774 0 0 1-11.445 5.3H45.117a15 15 0 0 1-14.835-17.22L57.9 332.086h47.8a15 15 0 0 0 0-30H57.9l-27.618-132.78a15 15 0 0 1 14.835-17.22H467.1a15 15 0 0 1 14.835 17.22l-27.621 132.781h-47.8a15 15 0 0 0 0 30h47.8l27.622 132.781a14.765 14.765 0 0 1-3.389 11.914Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 489",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(91.109 60.086)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 490",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(392.109 60.086)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1152",
    d: "M257.109 272.086a60.008 60.008 0 0 0-116.582-20 15 15 0 0 0 28.286 10 30.005 30.005 0 1 1 28.3 40H178.47a15 15 0 0 0 0 30h18.64a30 30 0 1 1-28.3 40 15 15 0 0 0-28.286 10 60 60 0 1 0 96.228-65 59.871 59.871 0 0 0 20.357-45Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1153",
    d: "M353.187 213.861a15 15 0 0 0-15.4.744l-45 30a15 15 0 0 0 16.641 24.962l21.68-14.453v151.972a15 15 0 1 0 30 0v-180a15.005 15.005 0 0 0-7.923-13.225Z"
  }))));
};
export default SvgGoogleCalendar;